import { doGet, doPost, doPut, doDelete } from 'src/api/client';

export async function reqPostPcsEdit(data, idCompany) {
  return doPost(`companies/pcs/edit`, { pcs: data, id_company: idCompany });
}

export async function reqGetPcs(idCompany = null) {
  return doGet(`companies/pcs`, { idCompany });
}

export async function reqGetCompanies() {
  return doGet(`companies`);
}

export async function reqGetCompany(companyId) {
  return doGet(`companies/${companyId}`);
}

export async function reqGetCompanyEoriValidity(companyId) {
  return doGet(`companies/${companyId}/eori_validity`);
}

export async function reqGetCompanyAgencies(companyId) {
  return doGet(`companies/${companyId}/agencies`);
}

export async function reqGetCompanyTiers(companyId) {
  return doGet(`companies/${companyId}/tiers`);
}

export async function reqGetCompanyUsers(companyId) {
  return doGet(`companies/${companyId}/users`);
}

export async function reqGetCompanySubscriptions(companyId) {
  return doGet(`companies/${companyId}/subscriptions`);
}

export async function reqGetAccountOwnerDetails(companyId) {
  return doGet(`companies/${companyId}/account_owner_details`);
}

export async function reqCreateCompany(companyInfo) {
  return doPost(`company`, companyInfo);
}

export async function reqUpdateCompany(companyInfo) {
  return doPut(`company`, companyInfo);
}

export async function reqGetCompanyOcrCredits(companyId) {
  return doGet(`companies/${companyId}/ocr-credits`);
}

export async function reqPostCompanyOcrCredits(companyId, amount) {
  return doPost(`companies/${companyId}/ocr-credits`, { amount });
}

export async function reqDeleteCompany(companyId) {
  return doDelete(`companies/${companyId}`);
}

export async function reqDeleteAgency(companyId, agencyId) {
  return doDelete(`companies/${companyId}/agencies/${agencyId}`);
}

export async function reqUpdateCompanySubscriptionRenewal(companyId, subscriptionId, willRenew) {
  return doPut(`companies/${companyId}/subscriptions/${subscriptionId}/renewal`, { will_renew: willRenew });
}

export async function reqAddCompanyInvoice(companyId, subscriptionId, invoice) {
  return doPost(`companies/${companyId}/subscriptions/${subscriptionId}/invoices`, invoice, false);
}

export async function reqDeleteCompanyInvoice(companyId, invoiceId) {
  return doDelete(`companies/${companyId}/invoices/${invoiceId}`);
}

export async function reqAddCompanySubscription(companyId, subscription) {
  return doPost(`companies/${companyId}/subscriptions`, subscription);
}

export async function reqSetCompanySubscriptionPayment(companyId, paymentDetails) {
  const subscriptionId = paymentDetails.subscription.id;
  const invoiceId = paymentDetails.invoiceId;
  return doPut(`companies/${companyId}/subscriptions/${subscriptionId}/invoices/${invoiceId}/payment_details`, {
    payment_date: paymentDetails.paymentDate,
    payment_means: paymentDetails.paymentMeans
  });
}

export async function reqSetCompanySubscriptionInvoiceVisibility(companyId, subscriptionId, invoiceId, isVisible) {
  return doPut(`companies/${companyId}/subscriptions/${subscriptionId}/invoices/${invoiceId}/visibility`, {
    is_visible: isVisible
  });
}
